import React from 'react';

import { HStack, Header } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';
import { FlatList } from 'react-native';

import TrophyIcon from 'components/icons/trophy';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useRoute } from 'hooks/navigation/use-route';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { routes } from 'utils/routing';

import { getQuestText } from './custom-text';
import { QuestCardError, QuestCardSkeleton } from './quest-card';
import { QuestCardWrapper } from './quest-card-wrapper';
import type { CardListItem } from './types';
import { useUserQuest } from './use-user-quest';

const CardListHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <HStack space="$2.5" alignItems="center" marginBottom="$6" paddingY="$2">
      <TrophyIcon />
      <Header margin={0}>{getQuestText(formatMessage)}</Header>
    </HStack>
  );
};

export const QuestSection = ({ showHeader = true }: { showHeader?: boolean }) => {
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const isQuestTilesEnable = useFlag(LaunchDarklyFlag.ENABLE_QUEST_TILES);
  const loyaltyId = loyaltyUser?.id;
  const { isLoading, error, refetch, userQuest, cmsQuestCardUI } = useUserQuest({
    loyaltyId,
  });
  const { params } = useRoute<{ questId: string }>();
  const questId = (params?.questId || '').trim();
  const { pathname } = useRoute<{ pathname: string }>();
  const { formatMessage } = useIntl();
  const { linkTo } = useNavigation();
  const activateChallengeUrl = formatMessage({ id: 'routes.loyaltyActivateQuest' });

  if (!isQuestTilesEnable || !loyaltyId) {
    return null;
  }

  if (isLoading) {
    return <QuestCardSkeleton />;
  }

  if (error) {
    return <QuestCardError refetch={refetch} />;
  }

  // User with no quest available...redirect Home
  if (!userQuest && !loyaltyLoading && !isLoading && !cmsQuestCardUI) {
    if (pathname.includes(activateChallengeUrl)) {
      linkTo(routes.base);
    }

    return null;
  }

  return (
    userQuest &&
    cmsQuestCardUI && (
      <FlatList<CardListItem>
        ListHeaderComponent={showHeader ? CardListHeader : null}
        data={[userQuest]}
        keyExtractor={({ loyaltyQuest }) => loyaltyQuest?.id}
        renderItem={({ item }) => {
          const { loyaltyQuest, cmsQuestCard } = item;

          return (
            <QuestCardWrapper
              quest={loyaltyQuest}
              cmsQuestCard={cmsQuestCard}
              cmsQuestCardUI={cmsQuestCardUI}
              questId={questId}
            />
          );
        }}
      />
    )
  );
};
